import React from 'react';
import styles from './index.module.less';
import { ArrowRightOutlined } from '@ant-design/icons';

export default function BottomCta({ data }: { data: any }) {
  const title = data?.contentInfo?.['section-cta']?.title || '';
  const bodyText = data?.contentInfo?.['section-cta']?.bodyText || [];
  const buttonText = data?.contentInfo?.['section-cta']?.buttonText || '';
  const cards = data?.contentInfo?.['section-cta']?.cards || [];
  const pcImgPath = cards?.[0]?.imgPath || '';
  const mobileImgPath = cards?.[1]?.imgPath || '';

  const handleClick = () => {
    // 滚动到页面顶部的反向搜索组件
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={styles.wrapper}>
      {/* PC 背景 */}
      <div className={styles.pcBg} style={{ backgroundImage: `url(${pcImgPath})` }} />
      {/* 移动端背景 */}
      <div className={styles.mobileBg} style={{ backgroundImage: `url(${mobileImgPath})` }} />
      {/* 内容 */}
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        {bodyText.map((text: string, index: number) => (
          <p key={index} className={styles.description}>
            {text}
          </p>
        ))}
        <button className={styles.button} onClick={handleClick}>
          <span>{buttonText}</span>
          <ArrowRightOutlined className={styles.arrowIcon} />
        </button>
      </div>
    </div>
  );
}
